import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTABanner() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20gradient%20background%20with%20soft%20coral%20and%20cream%20tones%2C%20gentle%20flowing%20organic%20shapes%2C%20elegant%20and%20airy%20atmosphere%2C%20modern%20SaaS%20style%20backdrop%2C%20no%20text%2C%20no%20sharp%20lines%2C%20dreamy%20pastel%20texture%2C%20clean%20contemporary%20design&width=1600&height=600&seq=cta-bg-2026-v1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-primary-600/80"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Ready to Explore VigorBuy Spreadsheet?
        </h2>
        <p className="text-white/90 text-sm md:text-base max-w-xl mx-auto mb-8">
          Discover the complete range of spreadsheet resources, templates, and guides designed to elevate your data management game.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white text-primary-600 text-base font-bold hover:bg-white/95 transition-all duration-200 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
          <Link
            to="/vigorbuy-spreadsheet-complete-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/20 text-white border-2 border-white/40 text-base font-semibold hover:bg-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Read Complete Guide
          </Link>
        </div>
      </div>
    </section>
  );
}